import { render, staticRenderFns } from "./labelInput.vue?vue&type=template&id=58f3caaa&scoped=true"
import script from "./labelInput.vue?vue&type=script&lang=js"
export * from "./labelInput.vue?vue&type=script&lang=js"
import style0 from "./labelInput.vue?vue&type=style&index=0&id=58f3caaa&prod&lang=scss&scoped=true"
import style1 from "./labelInput.vue?vue&type=style&index=1&id=58f3caaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f3caaa",
  null
  
)

export default component.exports